module.exports = __webpack_public_path__ + "static/media/logo-white-transparent.d484893a.png";